import Link from 'next/link';
import React, { JSX } from 'react';
import { SearchFilterMediaTypes } from 'search-gateway-client';

import { Text } from '@videoblocks/design-system';

import CategoryLinks from './CategoryLinks';

interface Props {
    mediaType: SearchFilterMediaTypes;
    selectedCategory?: string;
}

export const InternalSearchLinksSEO = ({ mediaType, selectedCategory }: Props): JSX.Element => {
    const formatCategory = (category: string) =>
        category
            .replace(/-/g, ' ')
            .split(' ')
            .map((word) => (word.toLowerCase() === 'and' ? word : word.charAt(0).toUpperCase() + word.slice(1)))
            .join(' ');

    const subCategories: { label: string; url: string }[] = []; // todo: construct subCategories for videos (with selectedCategory)

    if (!subCategories.length) {
        return <CategoryLinks mediaType={mediaType} />;
    }

    return (
        <div className="grid">
            <Text fontSize="sm" fontWeight="regular" className="text-gray-600 mt-5.5 mb-2.75">
                More subcategories in {formatCategory(selectedCategory!)}
            </Text>
            <div className="overflow-hidden flex overflow-x-scroll scrollbar-hidden whitespace-nowrap space-x-2 space-y-1">
                {subCategories.map(({ label, url }) => (
                    <Text fontWeight="regular" key={`subcategory-link-${label}`} asChild>
                        <Link
                            href={url}
                            prefetch={false}
                            className="text-gray-900 no-underline bg-gray-100 border border-gray-500 rounded-full py-2 px-6"
                        >
                            {label}
                        </Link>
                    </Text>
                ))}
            </div>
        </div>
    );
};
